import { useRef } from 'react';

export function useModalDrag() {
  const boxRef = useRef(null);
  const pos    = useRef({ dx: 0, dy: 0 });

  const onDragStart = (e) => {
    // Don't steal clicks on interactive elements
    if (e.target.closest('button, input, textarea, select, a')) return;
    e.preventDefault();

    const originX = e.clientX - pos.current.dx;
    const originY = e.clientY - pos.current.dy;
    let moved = false;

    const onMove = (ev) => {
      moved = true;
      pos.current.dx = ev.clientX - originX;
      pos.current.dy = ev.clientY - originY;
      if (boxRef.current)
        boxRef.current.style.transform =
          `translate(${pos.current.dx}px, ${pos.current.dy}px)`;
    };

    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      // If the user dragged, swallow the following click so it doesn't
      // accidentally trigger a backdrop-close handler
      if (moved)
        document.addEventListener('click', e => e.stopPropagation(),
          { once: true, capture: true });
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return { boxRef, onDragStart };
}